module.exports = __webpack_public_path__ + "static/media/mobile.e0324c09.svg";